<div
  class="lum-popover"
  (mouseenter)="onSetContentVisible(true)"
  (mouseleave)="onSetContentVisible(false)"
>
  <ng-content></ng-content>

  <div [@fadeIn] *ngIf="show" class="lum-popover__content p-6" [ngClass]="classes">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
